import { render, staticRenderFns } from "./databaseSchemaSelect.vue?vue&type=template&id=bf087fb8&scoped=true"
import script from "./databaseSchemaSelect.vue?vue&type=script&lang=js"
export * from "./databaseSchemaSelect.vue?vue&type=script&lang=js"
import style0 from "./databaseSchemaSelect.vue?vue&type=style&index=0&id=bf087fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf087fb8",
  null
  
)

export default component.exports